import { types, actions } from './requests'
export const CREATEPACKAGE_TYPES = {
    ...types('CREATEPACKAGE'),
}
export const CREATEPACKAGE_ACTIONS = {
    ...actions('CREATEPACKAGE'),
}